export const QUERY_STRING_KEYS = {
  PLATE_NUMBER: 'plate_number',
  LICENSE_PLATE_ID: 'license_plate_id',
  VEHICLE_TYPE: 'vehicle_type',
  ENERGY_SOURCE: 'energy_source',
} as const;
